/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateIndividuelleAnforderungDto } from '../../models/lexplus-create-individuelle-anforderung-dto';
import { LexplusIndividuelleAnforderungWriteResultDto } from '../../models/lexplus-individuelle-anforderung-write-result-dto';

export interface IndividuelleAnforderungWriteControllerCreateIndividuelleAnforderungV1$Params {
      body: LexplusCreateIndividuelleAnforderungDto
}

export function individuelleAnforderungWriteControllerCreateIndividuelleAnforderungV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungWriteControllerCreateIndividuelleAnforderungV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusIndividuelleAnforderungWriteResultDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungWriteControllerCreateIndividuelleAnforderungV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusIndividuelleAnforderungWriteResultDto>;
    })
  );
}

individuelleAnforderungWriteControllerCreateIndividuelleAnforderungV1.PATH = '/v1/compliance/firmeninterne-anforderungen';
